import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import { useEffect } from "react";
import HomePage from "@/pages/HomePage";
import ImpressumPage from "@/pages/ImpressumPage";
import DatenschutzPage from "@/pages/DatenschutzPage";
import LocationPage from "@/pages/LocationPage";
import CookieBanner from "@/components/CookieBanner";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import ProtectedRoute from "@/pages/admin/ProtectedRoute";
import Dashboard from "@/pages/admin/Dashboard";
import Inbox from "@/pages/admin/Inbox";
import AngeboteAdmin from "@/pages/admin/AngeboteAdmin";
import EinsteigerAdmin from "@/pages/admin/EinsteigerAdmin";
import KochkurseAdmin from "@/pages/admin/KochkurseAdmin";
import ComebackAdmin from "@/pages/admin/ComebackAdmin";

// Tracker-Params, die wir aus der URL entfernen (Google/Facebook/Bing/Yandex-Müll)
const TRACKING_PARAMS = [
  "ved", "usg", "sa", "sig", "source", "ei", "uact", "gs_lcp",
  "fbclid", "gclid", "msclkid", "dclid", "yclid", "_gl",
  "mc_cid", "mc_eid", "ref", "referrer"
];

const CleanUrl = () => {
  const { pathname, search } = useLocation();
  useEffect(() => {
    if (!search) return;
    const params = new URLSearchParams(search);
    let changed = false;
    TRACKING_PARAMS.forEach((p) => {
      if (params.has(p)) { params.delete(p); changed = true; }
    });
    if (changed) {
      const newSearch = params.toString();
      const newUrl = pathname + (newSearch ? `?${newSearch}` : "") + window.location.hash;
      window.history.replaceState({}, "", newUrl);
    }
  }, [pathname, search]);
  return null;
};

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      setTimeout(() => {
        const el = document.getElementById(hash.replace("#", ""));
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 100);
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);
  return null;
};

const ConditionalCookieBanner = () => {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return null;
  return <CookieBanner />;
};

function App() {
  return (
    <HelmetProvider>
      <div className="App min-h-screen bg-stone-50">
        <BrowserRouter>
          <CleanUrl />
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/impressum" element={<ImpressumPage />} />
            <Route path="/datenschutz" element={<DatenschutzPage />} />
            <Route path="/standort/:slug" element={<LocationPage />} />

            {/* Admin */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
              <Route index element={<Dashboard />} />
              <Route path="inbox" element={<Inbox />} />
              <Route path="angebote" element={<AngeboteAdmin />} />
              <Route path="einsteiger" element={<EinsteigerAdmin />} />
              <Route path="kochkurse" element={<KochkurseAdmin />} />
              <Route path="comeback" element={<ComebackAdmin />} />
            </Route>
          </Routes>
          <ConditionalCookieBanner />
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </div>
    </HelmetProvider>
  );
}

export default App;
